// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/80911.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


#left {
  left: 0px;
}

/*header*/

header {
  position: sticky;
  top: 0;
  z-index: 1;
}
h1 {
  margin: 20px 0;
  color: #fff;
}

.center {
  text-align: center;
}

.nav-wrapper {
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  width: 90%;
  height: 80px;
  border-radius: 0 0 15px 15px;
  padding: 0 25px;
  z-index: 2;
  background-image: linear-gradient(135deg, #027b9a 0%, #004658 100%);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  height: 100px;
}

.nav-tabs {
  display: flex;
  font-weight: 600;
  font-size: 18px;
  list-style: none;
}

.btn-logout {
  font-weight: 600;
  font-size: 18px;
  color: #000;
  text-decoration: none;
  background: transparent;
}

.btn-logout:hover {
  font-weight: 600;
  font-size: 18px;
  color: #7ca3e7;
  text-decoration: none;
  background: transparent;
}


.nav-tab a,
.logo-container a {
  font-weight: 600;
  font-size: 18px;
  color: #000;
  text-decoration: none;
}

.nav-tab a:hover,
.logo-container a:hover {
  font-weight: 600;
  font-size: 18px;
  color: #7ca3e7;
  text-decoration: none;
}

.nav-tab:not(:last-child) {
  padding: 10px 25px;
  margin: 0;
  border-right: 1px solid #eee;
}

.nav-tab:last-child {
  padding: 10px 0 0 25px;
}

.nav-tab,
.menu-btn {
  cursor: pointer;
}

.hidden {
  display: none;
}

@media screen and (max-width: 800px) {
  .nav-container {
    position: fixed;
    display: none;
    overflow-y: auto;
    z-index: -1;
    top: 0;
    right: 0;
    width: 280px;
    height: 100%;
    background: #fff;
    box-shadow: -1px 0 2px rgba(0, 0, 0, 0.2);
  }

  .nav-tabs {
    flex-direction: column;
    align-items: flex-end;
    margin-top: 80px;
    width: 100%;
  }

  .nav-tab:not(:last-child) {
    padding: 20px 25px;
    margin: 0;
    border-right: unset;
    border-bottom: 1px solid #f5f5f5;
  }

  .nav-tab:last-child {
    padding: 15px 25px;
  }

  .menu-btn {
    position: relative;
    display: block;
    margin: 0;
    width: 20px;
    height: 15px;
    cursor: pointer;
    z-index: 2;
    padding: 10px;
    border-radius: 10px;
  }

  .menu-btn .menu {
    display: block;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background: #111;
  }

  .menu-btn .menu:nth-child(2) {
    margin-top: 4px;
    opacity: 1;
  }

  .menu-btn .menu:nth-child(3) {
    margin-top: 4px;
  }

  #menuToggle:checked + .menu-btn .menu {
    transition: transform 0.2s ease;
  }

  #menuToggle:checked + .menu-btn .menu:nth-child(1) {
    transform: translate3d(0, 6px, 0) rotate(45deg);
  }

  #menuToggle:checked + .menu-btn .menu:nth-child(2) {
    transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
    opacity: 0;
  }

  #menuToggle:checked + .menu-btn .menu:nth-child(3) {
    transform: translate3d(0, -6px, 0) rotate(-45deg);
  }

  #menuToggle:checked ~ .nav-container {
    z-index: 1;
    display: flex;
    animation: menu-slide-left 0.3s ease;
  }
  @keyframes menu-slide-left {
    0% {
      transform: translateX(200px);
    }
    to {
      transform: translateX(0);
    }
  }
}


/*footer*/
.new_footer_area {
  background: #fbfbfd;
  bottom: 0;
}


.new_footer_top {
  padding: 120px 0px 270px;
  position: relative;
    overflow-x: hidden;
}
.new_footer_area .footer_bottom {
  padding-top: 5px;
  padding-bottom: 50px;
}
.footer_bottom {
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  color: #7f88a6;
  padding: 27px 0px;
}
.new_footer_top .company_widget p {
  font-size: 16px;
  font-weight: 300;
  line-height: 28px;
  color: #6a7695;
  margin-bottom: 20px;
}
.new_footer_top .company_widget .f_subscribe_two .btn_get {
  border-width: 1px;
  margin-top: 20px;
}
.btn_get_two:hover {
  background: transparent;
  color: #5e2ced;
}
.btn_get:hover {
  color: #fff;
  background: #6754e2;
  border-color: #6754e2;
  box-shadow: none;
}
a:hover, a:focus, .btn:hover, .btn:focus, button:hover, button:focus {
  text-decoration: none;
  outline: none;
}



.new_footer_top .f_widget.about-widget .f_list li a:hover {
  color: #5e2ced;
}
.new_footer_top .f_widget.about-widget .f_list li {
  margin-bottom: 11px;
}
.f_widget.about-widget .f_list li:last-child {
  margin-bottom: 0px;
}
.f_widget.about-widget .f_list li {
  margin-bottom: 15px;
}
.f_widget.about-widget .f_list {
  margin-bottom: 0px;
}
.new_footer_top .f_social_icon a {
  width: 44px;
  height: 44px;
  line-height: 43px;
  background: transparent;
  border: 1px solid #e2e2eb;
  font-size: 24px;
}
.f_social_icon a {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  font-size: 14px;
  line-height: 45px;
  color: #858da8;
  display: inline-block;
  background: #ebeef5;
  text-align: center;
  transition: all 0.2s linear;
}
.ti-facebook:before {
  content: "\\e741";
}
.ti-twitter-alt:before {
  content: "\\e74b";
}
.ti-vimeo-alt:before {
  content: "\\e74a";
}
.ti-pinterest:before {
  content: "\\e731";
}

.btn_get_two {
  box-shadow: none;
  background: #5e2ced;
  border-color: #5e2ced;
  color: #fff;
}

.btn_get_two:hover {
  background: transparent;
  color: #5e2ced;
}

.new_footer_top .f_social_icon a:hover {
  background: #5e2ced;
  border-color: #5e2ced;
color:white;
}
.new_footer_top .f_social_icon a + a {
  margin-left: 4px;
}
.new_footer_top .f-title {
  margin-bottom: 30px;
  color: #263b5e;
}
.f_600 {
  font-weight: 600;
}
.f_size_18 {
  font-size: 18px;
}
h1, h2, h3, h4, h5, h6 {
  color: #4b505e;
}
.new_footer_top .f_widget.about-widget .f_list li a {
  color: #6a7695;
}


.new_footer_top .footer_bg {
  position: absolute;
  bottom: 0;
  background: url("https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEigB8iI5tb8WSVBuVUGc9UjjB8O0708X7Fdic_4O1LT4CmLHoiwhanLXiRhe82yw0R7LgACQ2IhZaTY0hhmGi0gYp_Ynb49CVzfmXtYHUVKgXXpWvJ_oYT8cB4vzsnJLe3iCwuzj-w6PeYq_JaHmy_CoGoa6nw0FBo-2xLdOPvsLTh_fmYH2xhkaZ-OGQ/s16000/footer_bg.png") no-repeat scroll center 0;
  width: 100%;
  height: 266px;
}

.new_footer_top .footer_bg .footer_bg_one {
  background: url("https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEia0PYPxwT5ifToyP3SNZeQWfJEWrUENYA5IXM6sN5vLwAKvaJS1pQVu8mOFFUa_ET4JuHNTFAxKURFerJYHDUWXLXl1vDofYXuij45JZelYOjEFoCOn7E6Vxu0fwV7ACPzArcno1rYuVxGB7JY6G7__e4_KZW4lTYIaHSLVaVLzklZBLZnQw047oq5-Q/s16000/volks.gif") no-repeat center center;
  width: 330px;
  height: 105px;
background-size:100%;
  position: absolute;
  bottom: 0;
  left: 30%;
  animation: myfirst 22s linear infinite;
}

.new_footer_top .footer_bg .footer_bg_two {
  background: url("https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhyLGwEUVwPK6Vi8xXMymsc-ZXVwLWyXhogZxbcXQYSY55REw_0D4VTQnsVzCrL7nsyjd0P7RVOI5NKJbQ75koZIalD8mqbMquP20fL3DxsWngKkOLOzoOf9sMuxlbyfkIBTsDw5WFUj-YJiI50yzgVjF8cZPHhEjkOP_PRTQXDHEq8AyWpBiJdN9SfQA/s16000/cyclist.gif") no-repeat center center;
  width: 88px;
  height: 100px;
background-size:100%;
  bottom: 0;
  left: 38%;
  position: absolute;
  animation: myfirst 30s linear infinite;
}

@keyframes myfirst {
0% {
  left: -25%;
}
100% {
  left: 100%;
}
}

/*************footer End*****************/

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #007bff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

p {
  font-size: 18px;
  margin-top: 10px;
  color: #555;
}


@media screen and (max-width: 768px) {
  .nav-wrapper {
    flex-direction: column;
    height: auto;
    padding: 10px 0;
  }

  .nav-tabs {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }

  .nav-tab {
    padding: 10px 0;
  }
}

/* Responsive Design for Footer */
.new_footer_top {
  padding: 50px 0px 100px;
}

@media screen and (max-width: 768px) {
  .new_footer_top {
    padding: 30px 15px;
  }

  .new_footer_top .company_widget p {
    font-size: 14px;
  }

  .f_social_icon a {
    width: 36px;
    height: 36px;
    line-height: 36px;
  }
}

@media screen and (max-width: 480px) {
  .nav-tabs {
    font-size: 14px;
  }

  .btn_get_two {
    padding: 10px 20px;
    font-size: 14px;
  }
  

}

/* Spinner for loading (Responsive) */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.spinner {
  width: 40px;
  height: 40px;
}

/* Add media query for smaller devices */
@media screen and (max-width: 480px) {
  h1 {
    font-size: 24px;
  }

  p {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE;;cAEY;EACZ,UAAU;EACV,mCAAmC;EACnC,kCAAkC;EAClC,SAAS;EACT,yDAA0C;EAG1C,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,SAAS;AACX;;AAEA,SAAS;;AAET;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,mEAAmE;EACnE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;;AAGA;;EAEE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,0DAA0D;IAC1D,UAAU;EACZ;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,UAAU;IACV,aAAa;IACb,oCAAoC;EACtC;EACA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,wBAAwB;IAC1B;EACF;AACF;;;AAGA,SAAS;AACT;EACE,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,wBAAwB;EACxB,kBAAkB;IAChB,kBAAkB;AACtB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EAErB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;;;;AAIA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAGlB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB,WAAW;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,yTAAyT;EACzT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mTAAmT;EACnT,YAAY;EACZ,aAAa;AACf,oBAAoB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;EAET,sCAAsC;AACxC;;AAEA;EACE,qTAAqT;EACrT,WAAW;EACX,aAAa;AACf,oBAAoB;EAClB,SAAS;EACT,SAAS;EACT,kBAAkB;EAElB,sCAAsC;AACxC;;AAsBA;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;;AAGF;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".body {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: 0;\n  background-image: url(../public/80911.jpg);\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  background-size: cover;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n#left {\n  left: 0px;\n}\n\n/*header*/\n\nheader {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\nh1 {\n  margin: 20px 0;\n  color: #fff;\n}\n\n.center {\n  text-align: center;\n}\n\n.nav-wrapper {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  margin: auto;\n  width: 90%;\n  height: 80px;\n  border-radius: 0 0 15px 15px;\n  padding: 0 25px;\n  z-index: 2;\n  background-image: linear-gradient(135deg, #027b9a 0%, #004658 100%);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo {\n  height: 100px;\n}\n\n.nav-tabs {\n  display: flex;\n  font-weight: 600;\n  font-size: 18px;\n  list-style: none;\n}\n\n.btn-logout {\n  font-weight: 600;\n  font-size: 18px;\n  color: #000;\n  text-decoration: none;\n  background: transparent;\n}\n\n.btn-logout:hover {\n  font-weight: 600;\n  font-size: 18px;\n  color: #7ca3e7;\n  text-decoration: none;\n  background: transparent;\n}\n\n\n.nav-tab a,\n.logo-container a {\n  font-weight: 600;\n  font-size: 18px;\n  color: #000;\n  text-decoration: none;\n}\n\n.nav-tab a:hover,\n.logo-container a:hover {\n  font-weight: 600;\n  font-size: 18px;\n  color: #7ca3e7;\n  text-decoration: none;\n}\n\n.nav-tab:not(:last-child) {\n  padding: 10px 25px;\n  margin: 0;\n  border-right: 1px solid #eee;\n}\n\n.nav-tab:last-child {\n  padding: 10px 0 0 25px;\n}\n\n.nav-tab,\n.menu-btn {\n  cursor: pointer;\n}\n\n.hidden {\n  display: none;\n}\n\n@media screen and (max-width: 800px) {\n  .nav-container {\n    position: fixed;\n    display: none;\n    overflow-y: auto;\n    z-index: -1;\n    top: 0;\n    right: 0;\n    width: 280px;\n    height: 100%;\n    background: #fff;\n    box-shadow: -1px 0 2px rgba(0, 0, 0, 0.2);\n  }\n\n  .nav-tabs {\n    flex-direction: column;\n    align-items: flex-end;\n    margin-top: 80px;\n    width: 100%;\n  }\n\n  .nav-tab:not(:last-child) {\n    padding: 20px 25px;\n    margin: 0;\n    border-right: unset;\n    border-bottom: 1px solid #f5f5f5;\n  }\n\n  .nav-tab:last-child {\n    padding: 15px 25px;\n  }\n\n  .menu-btn {\n    position: relative;\n    display: block;\n    margin: 0;\n    width: 20px;\n    height: 15px;\n    cursor: pointer;\n    z-index: 2;\n    padding: 10px;\n    border-radius: 10px;\n  }\n\n  .menu-btn .menu {\n    display: block;\n    width: 100%;\n    height: 2px;\n    border-radius: 2px;\n    background: #111;\n  }\n\n  .menu-btn .menu:nth-child(2) {\n    margin-top: 4px;\n    opacity: 1;\n  }\n\n  .menu-btn .menu:nth-child(3) {\n    margin-top: 4px;\n  }\n\n  #menuToggle:checked + .menu-btn .menu {\n    transition: transform 0.2s ease;\n  }\n\n  #menuToggle:checked + .menu-btn .menu:nth-child(1) {\n    transform: translate3d(0, 6px, 0) rotate(45deg);\n  }\n\n  #menuToggle:checked + .menu-btn .menu:nth-child(2) {\n    transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);\n    opacity: 0;\n  }\n\n  #menuToggle:checked + .menu-btn .menu:nth-child(3) {\n    transform: translate3d(0, -6px, 0) rotate(-45deg);\n  }\n\n  #menuToggle:checked ~ .nav-container {\n    z-index: 1;\n    display: flex;\n    animation: menu-slide-left 0.3s ease;\n  }\n  @keyframes menu-slide-left {\n    0% {\n      transform: translateX(200px);\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n}\n\n\n/*footer*/\n.new_footer_area {\n  background: #fbfbfd;\n  bottom: 0;\n}\n\n\n.new_footer_top {\n  padding: 120px 0px 270px;\n  position: relative;\n    overflow-x: hidden;\n}\n.new_footer_area .footer_bottom {\n  padding-top: 5px;\n  padding-bottom: 50px;\n}\n.footer_bottom {\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 20px;\n  color: #7f88a6;\n  padding: 27px 0px;\n}\n.new_footer_top .company_widget p {\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 28px;\n  color: #6a7695;\n  margin-bottom: 20px;\n}\n.new_footer_top .company_widget .f_subscribe_two .btn_get {\n  border-width: 1px;\n  margin-top: 20px;\n}\n.btn_get_two:hover {\n  background: transparent;\n  color: #5e2ced;\n}\n.btn_get:hover {\n  color: #fff;\n  background: #6754e2;\n  border-color: #6754e2;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\na:hover, a:focus, .btn:hover, .btn:focus, button:hover, button:focus {\n  text-decoration: none;\n  outline: none;\n}\n\n\n\n.new_footer_top .f_widget.about-widget .f_list li a:hover {\n  color: #5e2ced;\n}\n.new_footer_top .f_widget.about-widget .f_list li {\n  margin-bottom: 11px;\n}\n.f_widget.about-widget .f_list li:last-child {\n  margin-bottom: 0px;\n}\n.f_widget.about-widget .f_list li {\n  margin-bottom: 15px;\n}\n.f_widget.about-widget .f_list {\n  margin-bottom: 0px;\n}\n.new_footer_top .f_social_icon a {\n  width: 44px;\n  height: 44px;\n  line-height: 43px;\n  background: transparent;\n  border: 1px solid #e2e2eb;\n  font-size: 24px;\n}\n.f_social_icon a {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  font-size: 14px;\n  line-height: 45px;\n  color: #858da8;\n  display: inline-block;\n  background: #ebeef5;\n  text-align: center;\n  -webkit-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.ti-facebook:before {\n  content: \"\\e741\";\n}\n.ti-twitter-alt:before {\n  content: \"\\e74b\";\n}\n.ti-vimeo-alt:before {\n  content: \"\\e74a\";\n}\n.ti-pinterest:before {\n  content: \"\\e731\";\n}\n\n.btn_get_two {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background: #5e2ced;\n  border-color: #5e2ced;\n  color: #fff;\n}\n\n.btn_get_two:hover {\n  background: transparent;\n  color: #5e2ced;\n}\n\n.new_footer_top .f_social_icon a:hover {\n  background: #5e2ced;\n  border-color: #5e2ced;\ncolor:white;\n}\n.new_footer_top .f_social_icon a + a {\n  margin-left: 4px;\n}\n.new_footer_top .f-title {\n  margin-bottom: 30px;\n  color: #263b5e;\n}\n.f_600 {\n  font-weight: 600;\n}\n.f_size_18 {\n  font-size: 18px;\n}\nh1, h2, h3, h4, h5, h6 {\n  color: #4b505e;\n}\n.new_footer_top .f_widget.about-widget .f_list li a {\n  color: #6a7695;\n}\n\n\n.new_footer_top .footer_bg {\n  position: absolute;\n  bottom: 0;\n  background: url(\"https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEigB8iI5tb8WSVBuVUGc9UjjB8O0708X7Fdic_4O1LT4CmLHoiwhanLXiRhe82yw0R7LgACQ2IhZaTY0hhmGi0gYp_Ynb49CVzfmXtYHUVKgXXpWvJ_oYT8cB4vzsnJLe3iCwuzj-w6PeYq_JaHmy_CoGoa6nw0FBo-2xLdOPvsLTh_fmYH2xhkaZ-OGQ/s16000/footer_bg.png\") no-repeat scroll center 0;\n  width: 100%;\n  height: 266px;\n}\n\n.new_footer_top .footer_bg .footer_bg_one {\n  background: url(\"https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEia0PYPxwT5ifToyP3SNZeQWfJEWrUENYA5IXM6sN5vLwAKvaJS1pQVu8mOFFUa_ET4JuHNTFAxKURFerJYHDUWXLXl1vDofYXuij45JZelYOjEFoCOn7E6Vxu0fwV7ACPzArcno1rYuVxGB7JY6G7__e4_KZW4lTYIaHSLVaVLzklZBLZnQw047oq5-Q/s16000/volks.gif\") no-repeat center center;\n  width: 330px;\n  height: 105px;\nbackground-size:100%;\n  position: absolute;\n  bottom: 0;\n  left: 30%;\n  -webkit-animation: myfirst 22s linear infinite;\n  animation: myfirst 22s linear infinite;\n}\n\n.new_footer_top .footer_bg .footer_bg_two {\n  background: url(\"https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhyLGwEUVwPK6Vi8xXMymsc-ZXVwLWyXhogZxbcXQYSY55REw_0D4VTQnsVzCrL7nsyjd0P7RVOI5NKJbQ75koZIalD8mqbMquP20fL3DxsWngKkOLOzoOf9sMuxlbyfkIBTsDw5WFUj-YJiI50yzgVjF8cZPHhEjkOP_PRTQXDHEq8AyWpBiJdN9SfQA/s16000/cyclist.gif\") no-repeat center center;\n  width: 88px;\n  height: 100px;\nbackground-size:100%;\n  bottom: 0;\n  left: 38%;\n  position: absolute;\n  -webkit-animation: myfirst 30s linear infinite;\n  animation: myfirst 30s linear infinite;\n}\n\n\n\n@-moz-keyframes myfirst {\n0% {\n  left: -25%;\n}\n100% {\n  left: 100%;\n}\n}\n\n@-webkit-keyframes myfirst {\n0% {\n  left: -25%;\n}\n100% {\n  left: 100%;\n}\n}\n\n@keyframes myfirst {\n0% {\n  left: -25%;\n}\n100% {\n  left: 100%;\n}\n}\n\n/*************footer End*****************/\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #007bff;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\np {\n  font-size: 18px;\n  margin-top: 10px;\n  color: #555;\n}\n\n\n@media screen and (max-width: 768px) {\n  .nav-wrapper {\n    flex-direction: column;\n    height: auto;\n    padding: 10px 0;\n  }\n\n  .nav-tabs {\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n  }\n\n  .nav-tab {\n    padding: 10px 0;\n  }\n}\n\n/* Responsive Design for Footer */\n.new_footer_top {\n  padding: 50px 0px 100px;\n}\n\n@media screen and (max-width: 768px) {\n  .new_footer_top {\n    padding: 30px 15px;\n  }\n\n  .new_footer_top .company_widget p {\n    font-size: 14px;\n  }\n\n  .f_social_icon a {\n    width: 36px;\n    height: 36px;\n    line-height: 36px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .nav-tabs {\n    font-size: 14px;\n  }\n\n  .btn_get_two {\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n  \n\n}\n\n/* Spinner for loading (Responsive) */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n}\n\n/* Add media query for smaller devices */\n@media screen and (max-width: 480px) {\n  h1 {\n    font-size: 24px;\n  }\n\n  p {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
